import get from 'lodash.get';

const getRenderStatus = (rootState) => get(rootState, 'ws.customHtml.status', null);

export default getRenderStatus;
